"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mallare": {
    "d7392116": [{
      "hkey": "9e914132",
      "slug": "baracchi-bertoni-codevilla",
      "name": "Baracchi-Bertoni-Codevilla",
      "primary": true,
      "skipSearch": false
    }],
    "codevilla": [{
      "hkey": "9e914132",
      "slug": "baracchi-bertoni-codevilla",
      "name": "Baracchi-Bertoni-Codevilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a2fd1e03": [{
      "hkey": "ffc8c36b",
      "slug": "mallare",
      "name": "Mallare",
      "primary": true,
      "skipSearch": false
    }],
    "eremita": [{
      "hkey": "ffc8c36b",
      "slug": "mallare",
      "name": "Mallare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e54e0c0c": [{
      "hkey": "ffc8c36b",
      "slug": "mallare",
      "name": "Mallare",
      "primary": true,
      "skipSearch": false
    }],
    "fornelli": [{
      "hkey": "ffc8c36b",
      "slug": "mallare",
      "name": "Mallare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;